import { useEffect } from 'react';
import { Button, Container, Row } from 'react-bootstrap';
import { PageTitle } from '../PageTitle';
import { SearchBox } from '../SearchBox/SearchBox';
import { BlogCard } from './BlogCard';

import { useDispatch, useSelector } from 'react-redux';
import t from '../../../text';
import { BLOGS_PER_PAGE } from '../../Constants';
import {
  fetchBlogs,
  fetchTotalPosts,
  selectBlogError,
  selectBlogLoading,
  selectBlogPage,
  selectBlogPostsData,
  selectBlogTotalPosts,
  setPage,
} from '../../redux/blog/blogSlice';
import { Spinner } from '../Spinner';

export const BlogHomepage = () => {
  const dispatch = useDispatch();
  const postsData = useSelector(selectBlogPostsData);
  const page = useSelector(selectBlogPage);
  const loading = useSelector(selectBlogLoading);
  const totalPosts = useSelector(selectBlogTotalPosts);
  const error = useSelector(selectBlogError);

  const allBlogsShown = BLOGS_PER_PAGE * page >= totalPosts;

  const viewMoreBlogs = () => {
    dispatch(setPage(page + 1));
    dispatch(fetchBlogs({ page: page + 1 }));
  };

  useEffect(() => {
    if (totalPosts === null) {
      dispatch(fetchTotalPosts());
    }

    if (postsData.length === 0) {
      dispatch(fetchBlogs({ page: 1 }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!postsData && (loading || error)) {
    return <PageWrapper>{loading ? <Spinner /> : <p>Unable to fetch blog data</p>}</PageWrapper>;
  }

  return (
    <PageWrapper>
      <Row xs={1} md={2} lg={3} className="row-gap-3">
        {postsData.map((blogData, i) => (
          <BlogCard blogData={blogData} key={i} />
        ))}
      </Row>
      {!allBlogsShown && (
        <div className="d-flex justify-content-center mt-5">
          <Button onClick={viewMoreBlogs} disabled={loading} style={{ minWidth: '450px' }}>
            {loading ? t('global.loading') : 'View More'}
          </Button>
        </div>
      )}
    </PageWrapper>
  );
};

const PageWrapper = ({ children }) => {
  const error = useSelector((state) => state.blog.blogError);
  return (
    <>
      <SearchBox />
      <PageTitle title={error ? 'Error' : 'Latest Posts From The Blog'} />
      <Container style={{ minHeight: '300px' }}>{children}</Container>
    </>
  );
};
